module.exports = "<ui-select multiple ng-model=\"$ctrl.value\" uis-open-close=\"$ctrl.updateValue(isOpen)\" close-on-select=\"false\">\n    <ui-select-match placeholder=\"{{ $ctrl.placeholder }}\" allow-clear=\"true\">\n        {{ $item.name }}\n    </ui-select-match>\n    <ui-select-choices repeat=\"treatment in $ctrl.treatments | filter: $select.search track by treatment.id\">\n        <span ng-bind=\"treatment.name\"></span>\n        <small ng-bind=\"treatment.category\"></small>\n    </ui-select-choices>\n</ui-select>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/treatment/views/treatments.select.html
// module id = 569
// module chunks = 0